<template>
  <div>
    <RichTextArea
      v-if="showContextFieldInsteadOfInput && isRegenerateButton && showContextField"
      custom-placeholder="Give us some extra context, or click 'Re-generate' to regenerate"
      :model-value="userContext"
      @update:modelValue="updateModelValue"
      hide-actions
      ai-enabled
      class="mt-0"
    />
    <DsInput
      icon="robot"
      icon-color="#843DFF"
      v-if="!showContextFieldInsteadOfInput && isRegenerateButton && showContextField"
      :model-value="userContext"
      v-model="userContext"
      ai-variant
      is-simplified
      placeholder="Give us some extra context, or click 'Re-generate' to regenerate"
      :disabled="disabled"
      :enable-feedback="hasGenerated && enableFeedback && modelValueIsChanged"
      :hide-feedback-text="hideFeedbackText"
      @feedback-thumbs-up="handleFeedback('positive')"
      @feedback-thumbs-down="handleFeedback('negative')"
    />
    <span v-if="isRegenerateButton && showContextField" class="regenerate-text">* Re-generating will overwrite the current {{
        label
      }}, this action is irreversible.</span>
    <div class="tw-flex mt-1">
      <DsButton
        :label="isGenerateButton ?  this.$t('generative_text_area_generate') + ' ' + (label === 'description' ? this.$t('generative_text_area_description') : label) : isRegenerateButton && showContextField ? $t('generative_text_area_re_generate') : $t('generative_text_area_re_generate') + ' ' + (label === 'description' ? $t('generative_text_area_description') : label)"
        variant="accent-rounded"
        size="small"
        :disabled="disabled || loading"
        @click="generate"
        :loading="loading"
      />
      <DsButton
        v-if="showSaveButton"
        :label="saveButtonLabel"
        :variant="saveButtonVariant"
        size="small"
        :disabled="disabled || saveButtonDisabled"
        @click="$emit('save')"
        :loading="saving"
      />
    </div>
  </div>
</template>
<script lang="ts">
  import { defineComponent, inject } from 'vue'
  import RichTextArea from '@/components/TextArea/RichTextArea.vue'
  import DsInput from '@/components/Form/DsInput.vue'
  import { GenerativeUserFeedbackType } from '@/Domain/Challenge/enums'
  import DsButton from '@/components/DsButton/DsButton.vue'

  export default defineComponent({
    name: 'GenerativeTextArea',
    emits: ['generate', 're-generate', 'save'],
    components: { RichTextArea, DsInput, DsButton },
    props: {
      modelValue: {
        type: String,
        required: true,
      },
      disabled: {
        type: Boolean,
      },
      loading: {
        type: Boolean,
        required: true,
        default: false,
      },
      label: {
        type: String,
        required: false,
        default: 'description',
      },
      saveButtonLabel: {
        type: String,
        required: false,
        default: 'Save',
      },
      saveButtonVariant: {
        type: String,
        required: false,
        default: 'secondary',
      },
      saveButtonDisabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      showSaveButton: {
        type: Boolean,
        required: false,
        default: false,
      },
      saving: {
        type: Boolean,
        required: false,
        default: false,
      },
      enableFeedback: {
        type: Boolean,
        required: true,
        default: false,
      },
      hideFeedbackText: {
        type: Boolean,
        default: false,
      },
      enableTextArea: {
        type: Boolean,
        required: false,
        default: false,
      },
      feedbackType: {
        type: String,
        required: true,
        validator: val => [
          GenerativeUserFeedbackType.challengeDescription,
          GenerativeUserFeedbackType.challengeObjective,
          GenerativeUserFeedbackType.challengeBackground,
        ].includes(val),
      },
      metadata: {
        type: String,
        required: false,
      },
    },
    data() {
      return {
        showContextField: false,
        userContext: '',
        hasGenerated: false,
        modelValueIsChanged: false,
        oldModelValue: '',
      }
    },
    computed: {
      isGenerateButton() {
        return this.modelValue?.replace('<p>', '').replace('</p>', '').length <= 10
      },
      isRegenerateButton() {
        return this.modelValue?.replace('<p>', '').replace('</p>', '').length >= 10
      },
      showContextFieldInsteadOfInput() {
        return this.enableTextArea
      },
    },
    mounted() {
      this.$bus = inject('emitter') as any
    },
    methods: {
      generate() {
        if (this.isGenerateButton) {
          this.userContext = ''
          this.$emit('generate', this.userContext)
        } else if (this.isRegenerateButton && this.showContextField) {
          this.$emit('re-generate', this.userContext)
          this.hasGenerated = true
          this.modelValueIsChanged = false
          this.oldModelValue = this.modelValue
        } else {
          this.showContextField = !this.showContextField
        }
      },
      updateModelValue(context) {
        this.userContext = context
      },
      handleFeedback(feedback: string) {
        // not implemented yet
        throw new Error('not implemented yet')
        /*storeUserFeedback(this.getIdForType(), this.feedbackType, feedback, this.userContext, this.oldModelValue, this.modelValue, this.metadata)
          .then(() => {
            /!*this.$store.commit(UI_MUTATION_TYPES.ADD_NOTIFICATION, {
              message: 'Thank you! Your feedback has been submitted! 🎉',
              type: NotificationType.generativeUserFeedback,
              url: '',
            })*!/
          })*/
      },
      getIdForType() {
        switch (this.feedbackType) {
          case GenerativeUserFeedbackType.challengeBackground:
          case GenerativeUserFeedbackType.challengeObjective:
          case GenerativeUserFeedbackType.challengeDescription:
            return Number(this.$route.params.id)
          default:
        }
      },
    },
    watch: {
      modelValue() {
        this.modelValueIsChanged = true
      },
    },
  })
</script>
<style lang="scss" scoped>
  .regenerate-text {
    font-size: 9px;
    margin: 0.25rem;
    color: red;
  }
</style>
